import * as React from "react";

function MessagesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M416 63.1V256c0 35.3-28.7 63.9-64 63.9l-128 .1-108.9 61.6c-2.2 1.7-4.7 2.4-7.1 2.4-6.2 0-12-4.9-12-12v-52H64c-35.25 0-64-28.7-64-64V63.1C0 28.75 28.75 0 64 0h288c35.3 0 64 28.75 64 63.1zm-272 247 67.4-38.1H352c8.7 0 16-7.2 16-16V64c0-8.75-7.3-16-16-16H64c-8.75 0-16 7.25-16 16v192c0 8.8 7.25 16 16 16h80v38.1zM256 384v-32h48v32c0 8.7 7.2 16 16 16h108.6l67.4 38.1V400h80c8.7 0 16-7.3 16-16V192c0-8.7-7.3-16-16-16H448v-48h128c35.3 0 64 28.7 64 63.1V384c0 35.3-28.7 64-64 64h-32v52c0 7.1-5.8 12-12 12-2.4 0-4.9-.7-7.1-2.4L416 448l-96-.1c-35.2 0-64-28.6-64-63.9z"
  }));
}

const ForwardRef = React.forwardRef(MessagesIcon);
export default ForwardRef;